<script lang="ts">
  import PagingButton from "../buttons/PagingButton.svelte";

  export let images: string[];
  let imageIndex: number = 0;

  $: displayImages = images.slice(imageIndex, imageIndex + 3);
  $: nextDisabled = imageIndex >= images.length / 3 - 1;
</script>

<div class="image-carousel" class:padding-bottom={images.length <= 3}>
  {#each displayImages as image, index}
    <div class="image-container" class:right-rotate={index % 2 === 1}>
      <img src={image} alt="issue" width="180px" height="220px" />
    </div>
  {/each}
</div>
{#if images.length > 3}
  <div class="actions">
    <PagingButton
      onNext={() => imageIndex++}
      onPrevious={() => imageIndex--}
      {nextDisabled}
      previousDisabled={imageIndex === 0}
    />
  </div>
{/if}

<style>
  .image-carousel {
    display: flex;
    flex-direction: row;
  }

  .padding-bottom {
    padding-bottom: 32px;
  }

  .image-container {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    background-color: var(--rekki-light);
    padding: 8px 8px 42px 8px;
    border-radius: 3px;
    transform: rotate(-3deg);
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05), 0px 36px 87px 0px rgba(0, 0, 0, 0.09);
  }

  .actions {
    z-index: 2;
    margin-top: 16px;
    margin-right: 8px;
    align-self: flex-end;
  }

  .right-rotate {
    transform: rotate(3deg);
  }

  .image-container img {
    border-radius: 2px;
    object-fit: cover;
  }
</style>
